export default __webpack_public_path__ + "static/media/developpemet.c9f33287.svg";